import tocInstance from "./index";
/**
 * 是否有帮助计数
 */
export function getIsHelp(params) {
  return tocInstance.get(`/help-center/add-help-count`, {
    params: {
      ...params
    }
  });
}
/**
 * 获取所有的帮助中心数据
 */
export function getAllHelpData() {
  return tocInstance.get(`/help-center/all-quick-help`);
}
/**
 * 获取某一条帮助数据
 */
export function getHelpViewData(id) {
  return tocInstance.get(`/help-center/help-view-data?id=${id}`);
}
/**
 * 查询帮助中心
 */
export function getSearchHelpData(keyword) {
  return tocInstance.get(`/help-center/search-help?keyword=${keyword}`);
}
